__turbopack_context__.v({
  "EmptyState": "empty-state-component-module-scss-module___OkvDG__EmptyState",
  "EmptyState__Icon": "empty-state-component-module-scss-module___OkvDG__EmptyState__Icon",
  "EmptyState__IconContainer": "empty-state-component-module-scss-module___OkvDG__EmptyState__IconContainer",
  "EmptyState__IconFree": "empty-state-component-module-scss-module___OkvDG__EmptyState__IconFree",
  "EmptyState__IconQuestion": "empty-state-component-module-scss-module___OkvDG__EmptyState__IconQuestion",
});
